function config(state = {}) {
    return state;
}

export default config;
